import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b107073c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-3 py-lg-5 px-2" }
const _hoisted_2 = { class: "title fs-5 fs-lg-4 text-center mb-3 mb-lg-5" }
const _hoisted_3 = { class: "row mx-0 shadow bg-white p-3 p-lg-5 rounded-4 mx-auto mb-5" }
const _hoisted_4 = { class: "text-center fs-6 fw-bold title-form mb-5 mb-lg-5 px-2 lh-lg" }
const _hoisted_5 = { class: "row m-0 p-0" }
const _hoisted_6 = { class: "row mx-0 px-0 gx-3 mb-4" }
const _hoisted_7 = { class: "w-max-content col-lg-3 col-form-label text-black" }
const _hoisted_8 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_9 = { class: "row mx-0 px-0 col-lg-7" }
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "mt-2 notice" }
const _hoisted_13 = { class: "row m-0 p-0 border-bottom mb-4" }
const _hoisted_14 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_15 = { class: "w-max-content col-lg-3 col-form-label text-black" }
const _hoisted_16 = { class: "w-max-content col-lg-2 col-form-label" }
const _hoisted_17 = { class: "col-lg-7" }
const _hoisted_18 = { class: "col-lg-8" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "mt-2 notice" }
const _hoisted_21 = { class: "d-flex justify-content-center mt-3 mt-lg-4" }

import Button from '@/components/button/index.vue'
import Status from '@/components/status/index.vue'
import ErrorMessage from '@/components/error-message'

import { computed, ref } from 'vue'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { PASSWORD_REGEX, SPECIAL_WORDS, REGEX_EMOJI, PASSWORD_FORMAT_REGEX } from '@/constants/regex'
import employeesService from '@/services/employees.service'

//validate
import useVuelidate from '@vuelidate/core'
import { required, maxLength, minLength, sameAs } from '@vuelidate/validators'

import { useRouter } from 'vue-router'
//TODO: CA52

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const rules = computed(() => {
  return {
    password: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      containsSpecialWords: function (value) {
        let count = 0
        SPECIAL_WORDS.forEach((e) => {
          if (value === e) count++
        })
        if (count === 0) return true
      },
      emoji: function (value) {
        return REGEX_EMOJI.test(value)
      },
      containsTypeSpecialCharacter: function (value) {
        let count = 0
        ;[...value].forEach((e) => {
          if (PASSWORD_FORMAT_REGEX.test(e)) count++
        })
        if (count === value.length) return true
      },
      containsType: function (value) {
        return PASSWORD_REGEX.test(value)
      },
    },
    password_confirmation: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(8),
      sameAsPassword: sameAs(formData.value.password),
    },
  }
})

const formData = ref({
  password: '',
  password_confirmation: '',
  reset_password_token: '',
})

const v$ = useVuelidate(rules, formData)

const router = useRouter()
const errorReset = ref<boolean>(false)
const samePass = ref<boolean>(false)
const loadingButton = ref<boolean>(false)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  loadingButton.value = true
  errorReset.value = false

  if (v$.value.$invalid) {
    loadingButton.value = false
    return
  }

  try {
    const response = await employeesService.employeesResetPassword({
      password: v$.value.password.$model,
      password_confirmation: v$.value.password_confirmation.$model,
      ...router.currentRoute?.value?.query,
    })

    if (response.status === 200) {
      router.replace('/community/users/reset_password_finished')
      loadingButton.value = false
    } else if (response.response?.data?.data[0]?.message_code === 'VALIDATE_NOT_CHANGED') {
      samePass.value = true
      loadingButton.value = false
    } else {
      errorReset.value = true
      loadingButton.value = false
    }
  } catch (error) {
    console.log('err', error.response)
    errorReset.value = true
    loadingButton.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)(`SC52title`)), 1),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(translate)(`SC52heading1`)), 1),
        (errorReset.value)
          ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
              key: 0,
              title: _unref(translate)('SC52errorResetPassword')
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (samePass.value)
          ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
              key: 1,
              title: '変更前とは異なる値を入力してください。'
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('password')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(Status)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  name: "password",
                  type: "password",
                  class: _normalizeClass(['form-control', _unref(v$).password.$error ? 'is-invalid' : '']),
                  placeholder: _unref(translate)('placeholder'),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).password.$model) = $event))
                }, null, 10, _hoisted_11), [
                  [
                    _vModelText,
                    _unref(v$).password.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(InputErrorMessage, {
                  title: 'password',
                  params: [8, 128],
                  validator: _unref(v$).password.$errors[0]?.$validator
                }, null, 8, ["validator"])
              ]),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(translate)(`SC52heading2`)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)('SA20passwordConfirm')), 1),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(Status)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("input", {
                  name: "confirmPassword",
                  type: "password",
                  class: _normalizeClass(['form-control', _unref(v$).password_confirmation.$error ? 'is-invalid' : '']),
                  placeholder: _unref(translate)(`SC52typeAgain`),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).password_confirmation.$model) = $event))
                }, null, 10, _hoisted_19), [
                  [
                    _vModelText,
                    _unref(v$).password_confirmation.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('SA20passwordConfirm'),
                  params: [8, 128],
                  validator: _unref(v$).password_confirmation.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ]),
              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(translate)(`SB20noticePassConfirm`)), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(Button, {
          title: _unref(translate)('change'),
          className: 'fw-bold',
          type: 'secondary',
          onClick: onSubmit,
          loading: loadingButton.value,
          disabled: loadingButton.value
        }, null, 8, ["title", "loading", "disabled"])
      ])
    ], 32)
  ]))
}
}

})